import React from 'react';
import { createTimeInstance, formatLocalizedDateTime } from '@utils/time';
import { handle400Statuses, sendApiRequest } from '@services/api';
import { addUrlParam } from '@utils';
import { logNetRequest } from '@utils/usefulFuncs';

const parseAndSortRecentDocs = (recentDocs) => {
  const recentDocsByDay = {};
  recentDocs.forEach((d) => {
    const { published_at: docDateString } = d;
    const reportDate = createTimeInstance(docDateString);
    const date = formatLocalizedDateTime('L', reportDate);
    if (recentDocsByDay[date]) {
      recentDocsByDay[date].push(d);
    } else {
      recentDocsByDay[date] = [d];
    }
  });

  const recentDocsBySecurity = {};
  recentDocs.forEach((d) => {
    const { security_id: sId } = d;
    if (recentDocsBySecurity[sId]) {
      recentDocsBySecurity[sId].push(d);
    } else {
      recentDocsBySecurity[sId] = [d];
    }
  });

  const days = Object.keys(recentDocsByDay);
  const sortedDays = days.sort((a, b) => (createTimeInstance(a).isAfter(createTimeInstance(b)) ? -1 : 1));
  return [sortedDays, recentDocsByDay];
};

export const useLatestCompanyDocs = () => {
  const [isLoading, setIsLoading] = React.useState(true);

  const [docs, setDocs] = React.useState([]);
  const [latestDocDays, setLatestDocDays] = React.useState([]);
  const [latestDocsByDayLookup, setLatestDocsByDayLookup] = React.useState({});

  const getDocData = async (params) => {
    const { company_ids, marketCap, startDate: _params_startDate } = params;
    setIsLoading(true);

    const minMarketCap = marketCap;
    let startDate = null;
    if (_params_startDate) {
      startDate = createTimeInstance(_params_startDate);
    }
    const dateFormat = '-L';
    const startDateApi = formatLocalizedDateTime(dateFormat, startDate);
    let URL = `v1/genai/documents?category=user&doc_tag_ids=` + company_ids[0];

    let URLParams = '';
    if (startDate) {
      URLParams = addUrlParam(URLParams, `start_date=${startDateApi}`);
    }
    if (minMarketCap) {
      URLParams = addUrlParam(URLParams, `market_cap_min=${minMarketCap}`);
    }
    URL += URLParams;
    const { status, data } = await sendApiRequest('get', URL);
    logNetRequest(status, data);
    handle400Statuses(status);

    if (status === 200) {
      setDocs(data.documents);
      const [sortedDays, recentDocsByDay] = parseAndSortRecentDocs(data.documents);
      setLatestDocDays(sortedDays);
      setLatestDocsByDayLookup(recentDocsByDay);
      setIsLoading(false);
    } else {
      return null;
    }
  };

  return {
    docs,
    latestDocDays,
    latestDocsByDayLookup,

    isLoading,
    getDocData,
  };
};
